export default __webpack_public_path__ + "static/media/slack.fcad3e17.jpg";